import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';
import { useAccount } from 'modules/account/hooks/useAccount';
import { RedirectAfterLogin } from 'modules/auth/components/RedirectAfterLogin';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTFA } from 'modules/tfa/hooks/useTFA';

export const RedirectHandler = () => {
  const { callback, isLoggedIn } = useAuth();
  const { isAccountInitialized } = useAccount();
  const { isTFADialogOpened } = useTFA();

  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  const shouldRedirectToCallback =
    isLoggedIn &&
    isAccountInitialized &&
    Boolean(callback.redirectURL) &&
    !isTFADialogOpened &&
    !isPartnerClient &&
    !isPartnerStatusLoading;

  if (shouldRedirectToCallback) {
    return <RedirectAfterLogin to={callback.redirectURL!} />;
  }

  return null;
};
